const genderOptions = [
    {label: "Male", value: "male"},
    {label: "Female", value: "female"},
    {label: "Other", value: "other"},
]

const facilityTypeOptions = [
    {label: "Primary", value: "primary"},
    {label: "Secondary", value: "secondary"},
    {label: "Tertiary", value: "tertiary"},
]

const regions = [
    {label: "Hhohho", value: "Hhohho"},
    {label: "Lubombo", value: "Lubombo"},
    {label: "Manzini", value: "Manzini"},
    {label: "Shiselweni", value: "Shiselweni"},
]
export {
    genderOptions,
    facilityTypeOptions,
    regions,
}